<ion-app>
  <ion-menu contentId="main-content" type="overlay" *ngIf="showMenu">
    <ion-header>
      <ion-toolbar color="primary">
        <ion-title>
          <div class="menu-header">
            <img src="assets/images/antflow.png" alt="AntFlow" class="menu-logo">
            <span>ANTFLOW</span>
          </div>
        </ion-title>
      </ion-toolbar>
    </ion-header>

    <ion-content>
      <div class="user-info" *ngIf="currentUser">
        <ion-avatar>
          <ion-icon name="person-circle"></ion-icon>
        </ion-avatar>
        <div class="user-details">
          <h3>{{ currentUser?.first_name || currentUser?.username || 'Utilisateur' }}</h3>
          <p>{{ currentUser?.email }}</p>
          <ion-badge [color]="currentUser?.role === 'admin' ? 'warning' : 'success'">
            {{ currentUser?.role || 'user' }}
          </ion-badge>
        </div>
      </div>

      <ion-list>
        <ion-menu-toggle auto-hide="false">
          <ion-item button routerLink="/home" routerLinkActive="active" detail="false">
            <ion-icon name="home-outline" slot="start"></ion-icon>
            <ion-label>Accueil</ion-label>
          </ion-item>

          <ion-item button routerLink="/ingestion" routerLinkActive="active" detail="false">
            <ion-icon name="cloud-upload-outline" slot="start"></ion-icon>
            <ion-label>Ingestion CV</ion-label>
          </ion-item>

          <ion-item button routerLink="/chat" routerLinkActive="active" detail="false">
            <ion-icon name="chatbubbles-outline" slot="start"></ion-icon>
            <ion-label>Recherche CV</ion-label>
          </ion-item>

          <ion-item button routerLink="/admin" routerLinkActive="active" detail="false">
            <ion-icon name="people-outline" slot="start"></ion-icon>
            <ion-label>Administration</ion-label>
          </ion-item>

          <ion-item button routerLink="/profile" routerLinkActive="active" detail="false">
            <ion-icon name="person-outline" slot="start"></ion-icon>
            <ion-label>Mon Profil</ion-label>
          </ion-item>
        </ion-menu-toggle>
      </ion-list>

      <ion-list class="logout-section">
        <ion-item button (click)="logout()" detail="false">
          <ion-icon name="log-out-outline" slot="start" color="danger"></ion-icon>
          <ion-label color="danger">Déconnexion</ion-label>
        </ion-item>
      </ion-list>
    </ion-content>
  </ion-menu>

  <ion-router-outlet id="main-content"></ion-router-outlet>
</ion-app>
